import React from 'react'

function EnterpriseConsultancy() {
    return (
        <div className='w-full bg-black text-white mt-20'>EnterpriseConsultancy</div>
    )
}

export default EnterpriseConsultancy;